import { Controller } from "@hotwired/stimulus"

// Handle mobile settings dropdown navigation
export default class extends Controller {
  navigate() {
    const selectedValue = this.element.value
    const currentPath = window.location.pathname

    // Navigate to the selected section using Turbo
    const newUrl = `${currentPath}?section=${selectedValue}`
    window.location.href = newUrl
  }
}